import { Button } from "@/shadcn/components/ui/button";
import { Calendar } from "@/shadcn/components/ui/calendar"; // Ensure this is the correct Calendar component
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { formatDueDate } from "@/utils/utils";
import { CalendarIcon } from "lucide-react";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

type DueDateRangePickerProps = {
  fromDate: Date | null;
  toDate: Date | null;
  onDateChange: (fromDate: Date | null, toDate: Date | null) => void;
  setFromDate: Dispatch<SetStateAction<Date | null>>;
  setToDate: Dispatch<SetStateAction<Date | null>>;
  modal: boolean;
  rangePickerRef: React.RefObject<HTMLDivElement>;
};

const DueDateRangePicker: React.FC<DueDateRangePickerProps> = ({
  fromDate,
  toDate,
  onDateChange,
  setFromDate,
  setToDate,
  modal,
  rangePickerRef,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleFieldDueDate = (fromDate: Date | null, toDate: Date | null) => {
    console.log("fromDate", fromDate);
    console.log("toDate", toDate);
    setFromDate(fromDate);
    setToDate(toDate);
    onDateChange(fromDate, toDate);
  };

  useEffect(() => {
    console.log("toDate", toDate);
    console.log("fromDate", fromDate);
  }, [toDate, fromDate]);

  return (
    <Popover modal={modal}>
      <PopoverTrigger asChild>
        <Button
          id="edit-due-date-range"
          variant="outline"
          className={`w-full justify-start text-left font-normal ${
            (!fromDate || !toDate) && "text-muted-foreground"
          }`}
          onMouseDown={(e) => {
            e.stopPropagation();
            if (!isCalendarOpen) {
              setIsCalendarOpen(true);
            }
          }}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {fromDate && toDate ? (
            `${formatDueDate(fromDate)} - ${formatDueDate(toDate)}`
          ) : (
            <span>Pick a date range</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        ref={rangePickerRef}
        className="w-auto p-0"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {isCalendarOpen && (
          <>
            <Calendar
              mode="range"
              selected={{
                from: fromDate ? new Date(fromDate) : undefined,
                to: toDate ? new Date(toDate) : undefined,
              }}
              onSelect={(range) => {
                if (range) {
                  const { from, to } = range;
                  handleFieldDueDate(from ?? null, to ?? null);
                }
              }}
              autoFocus
              weekStartsOn={1}
            />
            {/* Reset Button */}
            <Button
              variant="outline"
              className="w-full justify-center"
              onClick={() => {
                handleFieldDueDate(null, null);
              }}
            >
              Reset
            </Button>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DueDateRangePicker;
